import React from 'react'
import SchoolData from '../SchoolData'
import bell from '../images/bell.gif'
import { NavLink } from 'react-router-dom'
import five from '../images/undraw_Processing_re_tbdu.svg'
import style from './courseComponent.module.css'


const CourseComponentSchool = ({ title }) => {

    return (
        <>
            <div className="container-fluid p-0 m-0">
                <div className="container-fluid p-5 m-0 course_header" >
                    <div className={`container text-white ${style.full_container}`}>
                        <div className="row">
                            <div className="col-lg-8 col-md-6 col-sm-12 col-xs-12 mx-auto my-auto order-lg-1 order-2 order-2">
                                {
                                    SchoolData.map((item, ind) => {
                                        if (title == item.class) {
                                            return (
                                                <>
                                                    <h1 className="font-weight-bold">{item.class}</h1>
                                                    <p>{item.desc}</p>
                                                    <p><i>{item.content}</i></p>
                                                    <h5>Course Creator:<i> <b>{item.creator ? item.creator : "CareerGrads"}</b></i></h5>
                                                </>
                                            )
                                        }
                                    })
                                }
                            </div>
                            <div className="col-lg-4 col-md-6 col-sm-12 col-xs-12 mx-auto order-lg-2 my-auto order-sm-1 order-xs-1">
                                {
                                    SchoolData.map((item, ind) => {
                                        if (title == item.class) {
                                            return (
                                                <div className={`card-img mb-2 ${style.image_container}`}>
                                                    <img src={item.imageUrl} className="img-responsive img-fluid"
                                                        style={{ width: "24rem", height: "auto" }} />
                                                </div>
                                            )
                                        }
                                    })
                                }
                            </div>
                        </div>
                    </div>
                </div>
                {/* <div className="container" >
                    <div className="d-flex justify-content-center align-items-center text-center border rounded-2 bg-white shadow-sm my-5 mx-auto" style={{ margin: "-10px 0 0 0" }}>
                        <img src={bell} style={{ width: "80px", height: "80px" }} /><h4>
                            We Conduct <span className="font-weight-bold text-primary">Live Workshops & Classes </span>for you to get job ready.
                        </h4>
                    </div>
                </div> */}

                <div className="container my-4 p-3" >
                    <h2><strong className="text-primary">Benefit's</strong></h2>
                    <div className="row ">
                        <div className="col-lg-6 col-md-6 col-sm-12 text-center mx-auto ml-5 order-1 order-lg-last rounded-3">
                            <img src={five} className="img-responsive img-fluid text-center" style={{ width: "80%" }} />
                        </div>
                        <div className="col-lg-6 col-md-6 col-sm-12 order-1 order-lg-first ">
                            <ul className="mt-4 ml-4 list_style text-left font-weight-bold" >
                                <li className="mt-3"><i className="fa fa-chevron-circle-right" aria-hidden="true" style={{ marginRight: '8px', fontWeight: "bolder" }}></i>Interactive videos for all your needs.</li>
                                <li className="mt-3"><i className="fa fa-chevron-circle-right" aria-hidden="true" style={{ marginRight: '8px', fontWeight: "bolder" }}></i>All chapters have been covered for Science and
                            Maths.</li>
                                <li className="mt-3"><i className="fa fa-chevron-circle-right" aria-hidden="true" style={{ marginRight: '8px', fontWeight: "bolder" }}></i>Keeping in mind the language diversities, the videos are available in
                            English and Hindi for a better understanding of the students. </li>
                                <li className="mt-3"><i className="fa fa-chevron-circle-right" aria-hidden="true" style={{ marginRight: '8px', fontWeight: "bolder" }}></i>Do share these videos with your
                            friends and help them discover the fun of learning!</li>
                            </ul>

                        </div>
                    </div>
                </div>

                <div className="container my-5 p-3 ">
                    <div className='row '>
                        <div className="col-lg-6 col-md-6 col-sm-12  shadow-sm  rounded-3">
                            <h2><strong className="text-primary">FAQ's</strong></h2>
                            <ul className="mt-4 list_style text-left font-weight-bold" >
                                <li className="mt-3"><i className="fa fa-chevron-circle-right" aria-hidden="true" style={{ marginRight: '8px', fontWeight: "bolder" }}></i>Do I have to pay to watch these videos?<br/>
                                These videos are absolutely free for students to watch                                    
                                </li>
                                <li className="mt-3"><i className="fa fa-chevron-circle-right" aria-hidden="true" style={{ marginRight: '8px', fontWeight: "bolder" }}></i>Is there counselling available for students.<br />
                                Provide your details through the <NavLink to="/contact">Contact Us</NavLink> section and we'll get in touch with you.
                                    </li>

                                <li className="mt-3"><i className="fa fa-chevron-circle-right" aria-hidden="true" style={{ marginRight: '8px', fontWeight: "bolder" }}></i>Are there personalised courses available.<br />
                                    <span className="font-weight-bolder text-primary" style={{ cursor: "pointer" }}>Yes.</span> Provide your details through the Contact Us section and we'll get in touch with you.
                                 </li>


                                <li className="mt-3"><i className="fa fa-chevron-circle-right" aria-hidden="true" style={{ marginRight: '8px', fontWeight: "bolder" }}></i>I am a school/organisation and want to avail services for targetted training for students.<br />
                                Reach out to us on:
                                    <a href="mailto:info@careergrads.com"> info@careergrads.com</a>
                                </li>
                            </ul>
                        </div>

                        <div className="col-lg-6 col-md-6 col-sm-12  ">
                            <div className="card shadow">
                                <div className="card-body font-weight-bold">
                                    {
                                        SchoolData.map((item, ind) => {
                                            if (title == item.class) {
                                                return (
                                                    <>
                                                        <h4 className="text-primary font-weight-bold text-center">Content</h4>
                                                        <ul className="list-unstyled">
                                                            {item.course_content.map((items) => {
                                                                return (
                                                                    <>
                                                                        {items.maths ? <h2 className="text-primary text-center">Maths</h2> : null}
                                                                        {items.maths ? items.maths.map((content) => {
                                                                            return (
                                                                                <>
                                                                                    <li className="my-3"><i className="fa fa-desktop mx-2" aria-hidden="true"></i> {content}</li>
                                                                                </>)
                                                                        }) : null}
                                                                        {items.evs ? <h2 className="text-primary text-center">EVS</h2> : null}
                                                                        {items.evs ? items.evs.map((content) => {
                                                                            return (
                                                                                <li className="my-3"><i className="fa fa-desktop mx-2" aria-hidden="true"></i>  {content}</li>
                                                                            )
                                                                        }) : null}
                                                                        {items.science ? <h2 className="text-primary text-center">Science</h2> : null}
                                                                        {items.science ? items.science.map((content) => {
                                                                            return (
                                                                                <li className="my-3"><i className="fa fa-desktop mx-2" aria-hidden="true"></i>  {content}</li>
                                                                            )
                                                                        }) : null}
                                                                        {items.biology ? <h2 className="text-primary text-center">Biology</h2> : null}
                                                                        {items.biology ? items.biology.map((content) => {
                                                                            return (
                                                                                <li className="my-3"><i className="fa fa-desktop mx-2" aria-hidden="true"></i>  {content}</li>
                                                                            )
                                                                        }) : null}
                                                                        {items.chemistry ? <h2 className="text-primary text-center">Chemistry</h2> : null}
                                                                        {items.chemistry ? items.chemistry.map((content) => {
                                                                            return (
                                                                                <li className="my-3"><i className="fa fa-desktop mx-2" aria-hidden="true"></i>  {content}</li>
                                                                            )
                                                                        }) : null}
                                                                        {items.physics ? <h2 className="text-primary text-center">Physics</h2> : null}
                                                                        {items.physics ? items.physics.map((content) => {
                                                                            return (
                                                                                <li className="my-3"><i className="fa fa-desktop mx-2" aria-hidden="true"></i>  {content}</li>
                                                                            )
                                                                        }) : null}
                                                                    </>
                                                                )
                                                            })}
                                                        </ul>
                                                        <a href="https://play.google.com/store/apps/details?id=com.career_grads"><button className="btn btn-block btn-explore bg-primary text-white
                                                            font-weight-bold my-3 mx-auto">
                                                            Get Our App</button></a>
                                                    </>
                                                );
                                            }

                                        })
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </>

    )
}

export default CourseComponentSchool
